import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, DialogContent,
    TablePagination, Typography, InputAdornment, IconButton, Tooltip, Tab, Card, CardContent, Tabs, Divider, Snackbar, Popover, Container
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import Breadcrumb from "../reusableComponent/Breadcrumb";
import { StyledTableCell, StyledTableRow } from "../reusableComponent/StyledTable";
import { useDispatch, useSelector } from "react-redux";
import { editDeleteCustomerSupplierPayment, getCustomerSupplierPaymentList, } from "../../actions/actions";
import { SearchOutlined } from "@mui/icons-material";
import styles from '../../styles.module.css';
import { Icon } from '@iconify/react';
import ExcelDownload from "../reusableComponent/ExcelDownload";
import Customer_Supplier_PaymentAddTab from "./Customer_Supplier_PaymentAddTab";
import { dateConversion, dateConversionOnEntryPage } from "../reusableComponent/dateConversionOnEntryPage";
import Customer_Supplier_PaymentPrint from "./Customer_Supplier_PaymentPrint";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import { BootstrapDialog, BootstrapDialogTitle } from "../reusableComponent/BootstrapDialog";
import Customer_Supplier_PaymentDetails from "./Customer_Supplier_PaymentDetails";
import EditIcon from '@mui/icons-material/Edit';
const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value } = props;
    return (
        <div className="print-source" ref={ref}>
            <Customer_Supplier_PaymentPrint paymentPrint={value} />
        </div>
    );
});

const ComponentToPrintQuotationWrapper = ({ paymentPrint }) => {
    const ref = useRef();

    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}>  <Icon icon="flat-color-icons:print" width="20" height="20" />  <span style={{ marginLeft: '22px' }}>  Print Record </span> </span>}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={paymentPrint} />
            </div>
        </div>
    );
};

function Customer_Supplier_PaymentList(props) {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const location = useLocation();
    let ref = useRef();
    const tableRef = useRef(null);
    // const [open, setOpen] = React.useState(false);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [info, setInfo] = useState({});
    const [successMessage, setSuccessMessage] = useState(null);
    const [openOption, setOpenOption] = useState('');

    const handleClickOpenPopup = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption('PurchaseUpdate')
    };
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const [isLoaded, setIsLoaded] = useState(false);

    const [q, setQ] = useState("");
    const [searchParam] = useState(["paymentReferenceNo", "payment_date", "CNS_Type", "CNS_Name", "totalPaidAmt", "instrumentNo", "remark", "payment_mode", "paymentStatus"]);

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();


    const rows = useSelector(state => state.customer_supplier_payment.customer_supplier_payment)
    const fetchData = () => {
        dispatch(getCustomerSupplierPaymentList({ companyId: userInfo.companyId, CNS_Type: location.pathname == '/sales/customer-payment' ? 'Customer' : 'Supplier' }))

    };
    useEffect(() => {
        fetchData()
    }, []);
    const [deleteMessage, setDeleteMessage] = useState(null);
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.customer_supplier_payment.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                fetchData();
                setOpenPopup(false);
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);


    const deleteRecord = (id) => {
        dispatch(editDeleteCustomerSupplierPayment({ id: id, modifiedBy: userInfo.userId, modifiedAt: dateConversionOnEntryPage(new Date()), changedUpdatedValue: 'delete' }))
        setIsDelete(false);
        fetchData()
    }

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
        // setOpen(false);
        setAnchorEl(null);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
        // setOpen(false);
        setAnchorEl(null);
        setOpenPopup(false);
    };
    const handleDetails = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption('PaymentDetails')
    }

    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };

    function search() {
        return rows && rows.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem] && item[newItem].toString().toLowerCase().indexOf(q.toLowerCase()) > -1
                );
            });
        });
    }

    const [sortBy, setSortBy] = useState(null);

    const handleSort = (property) => {
        const isAsc = sortBy === property && sortBy !== null;
        setSortBy(isAsc ? property + '_desc' : property);
        rows && rows.sort((a, b) => {
            if (typeof a[property] === 'number' && typeof b[property] === 'number') {
                return isAsc ? a[property] - b[property] : b[property] - a[property];
            } else if (typeof a[property] === 'string' && typeof b[property] === 'string') {
                return isAsc ? a[property].localeCompare(b[property]) : b[property].localeCompare(a[property]);
            } else {
                // Handle other data types here, or you can set a default value if needed
                // For example, you can return 0 to indicate no sorting needed for other data types.
                return 0;
            }
        });
    };

    const fields = ['CNS_payment_id', 'paymentReferenceNo', 'payment_date', 'CNS_Name', "totalPaidAmt", "totalDue", "payment_mode", "bankName", "instrumentNo", "remark"];
    const labels = ['Id', 'Payment Ref No', 'Payment Date', 'Party Name', "Amount", "Total Due", "Payment Mode", "Bank Name", "Instrument No", "Remark"];

    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    var containsSales = location.pathname.includes('/sales/');
    console.log(props.backBtnTab)

    const navigate = useNavigate()
    const backBtn = props.currentTab
    const navigateToAddEdit = (row) => {
        const state = {
            row,
            // invoiceSettingList,
            // docNoFormateAvailable,
            backBtn
        }
        navigate(containsSales === true ? '/sales/add-customer-payment' : '/purchase/add-supplier-payment', { state });
    };
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <>
            <Box sx={{ display: 'flex' }}>
                <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                    <Grid item md={7} xs={0}>

                    </Grid>
                    <Grid item md={5} xs={12} style={{ display: 'flex', }}>
                        <Box className={`${styles.excel_box}`}>
                            <ExcelDownload
                                data={rows}
                                fields={fields}
                                labels={labels}
                                filename="Payment List"
                            />
                        </Box>
                        <TextField
                            fullWidth
                            sx={{
                                "& .MuiInputBase-root": {
                                    height: 25,
                                    fontSize: '11px',
                                    paddingLeft: '1px',
                                }
                            }}
                            type="search"
                            name="search"
                            placeholder="Search"
                            value={q}
                            size="small"
                            onChange={(e) => setQ(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start" >
                                        <IconButton sx={{ padding: '4px' }}>
                                            <SearchOutlined className={`${styles.search_icon}`} />
                                            <Divider orientation="vertical" flexItem />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <Button variant="contained" className={`${styles.add_btn}`} onClick={() => navigateToAddEdit()}>
                            <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Create New
                        </Button>
                    </Grid>
                </Grid>
            </Box>

            <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 350 }}>
                <Table sx={{ minWidth: 800 }} size="small" stickyHeader>
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                            <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('paymentReferenceNo')}>Reference No <span className={`${styles.sort_icon}`}> {sortBy === 'paymentReferenceNo' ? '▲' : '▼'} </span> </StyledTableCell>
                            <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('CNS_Name')}>{location.pathname == '/sales/customer-payment' ? 'Customer Name' : 'Supplier Name'} <span className={`${styles.sort_icon}`}> {sortBy === 'CNS_Name' ? '▲' : '▼'} </span> </StyledTableCell>
                            <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('totalPaidAmt')}>Paid Amount <span className={`${styles.sort_icon}`}> {sortBy === 'totalPaidAmt' ? '▲' : '▼'} </span> </StyledTableCell>
                            <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('payment_date')}>Date <span className={`${styles.sort_icon}`}> {sortBy === 'payment_date' ? '▲' : '▼'} </span> </StyledTableCell>
                            <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('payment_mode')}>Payment Mode <span className={`${styles.sort_icon}`}> {sortBy === 'payment_mode' ? '▲' : '▼'} </span> </StyledTableCell>
                            <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('bankName')}>Payment Through <span className={`${styles.sort_icon}`}> {sortBy === 'bankName' ? '▲' : '▼'} </span> </StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {search(rows)
                            .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                            )
                            .map((row, index) => (
                                <StyledTableRow
                                    key={row.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <StyledTableCell align="center">
                                        <PopupState variant="popover" popupId="demo-popup-popover">
                                            {(popupState) => (
                                                <div>
                                                    <MoreHorizIcon
                                                        id={styles.actionBtn}
                                                        alt="translator"
                                                        variant="contained"
                                                        {...bindTrigger(popupState)}
                                                        />
                                                        <Popover
                                                          
                                                            {...bindPopover(popupState)}
                                                        anchorOrigin={{
                                                            vertical: "right",
                                                            horizontal: "center"
                                                        }}
                                                        transformOrigin={{
                                                            vertical: "right",
                                                            horizontal: "center"
                                                        }}
                                                    >
                                                        <Container className={`${styles.tbl_action}`}>
                                                            <>
                                                                <Button className={`${styles.list_tbl_action_btn}`} onClick={() => navigateToAddEdit(row)}>
                                                                    <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} />
                                                                    <span style={{ marginRight: '13px' }}> Edit Record</span>
                                                                </Button>
                                                                {/* <Customer_Supplier_PaymentAddTab editInfo={row} key={row.CNS_payment_id} /> */}
                                                                <Button onClick={popupState.close} className={`${styles.list_tbl_action_btn}`}>
                                                                    <ComponentToPrintQuotationWrapper key={index} paymentPrint={row} />
                                                                </Button>
                                                                <Button className={`${styles.list_tbl_action_btn}`} onClick={() => { handleDelete(row); popupState.close()}}>
                                                                    <Icon icon="ic:baseline-delete-forever" color="#c70000" width="20" height="20" /> Delete Record
                                                                </Button>
                                                            </>
                                                        </Container>
                                                    </Popover>
                                                </div>
                                            )}
                                        </PopupState>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`} sx={{ color: 'blue' }} onClick={() => handleDetails(row)}>
                                        <span style={{ cursor: 'pointer', color: 'blue' }} > {row.paymentReferenceNo}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.CNS_Name}</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body}`} >{(row.totalPaidAmt).toFixed(2)}</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row.payment_date)}</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.payment_mode}</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.bank_id === null ? '-' : row.bankName}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                sx={{ px: 2 }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                    'aria-label': 'Previous Page',
                }}
                nextIconButtonProps={{
                    'aria-label': 'Next Page',
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <Dialog open={isDelete}
                PaperProps={{
                    sx: {
                        minWidth: "35%",
                        minHeight: "22%",
                        borderRadius: '8px'
                    }
                }}>
                <DialogTitle className={`${styles.dilog_delete_title}`}>
                    Confirm Delete The Record?
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            right: 0,
                            top: 0,
                            float: 'right'
                        }} >
                        <CloseIcon style={{ height: '18px', color: '#000000' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={`${styles.dilog_delete_content}`}>
                    The BillCube will remove this record # {deleteInfo && deleteInfo.paymentReferenceNo}
                </DialogContent>
                <DialogActions sx={{ padding: '10px', }}>
                    <Button onClick={handleClose} className={`${styles.dilog_delete_no_btn}`} variant='outlined'>
                        No
                    </Button>
                    <Button onClick={() => deleteRecord(deleteInfo.CNS_payment_id)} className={`${styles.dilog_delete_yes_btn}`} variant='outlined'>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        height: "95%",
                        minWidth: "75%",
                    }
                }}
                onClose={handleClose}
                open={openPopup}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    {openOption === 'PaymentDetails' && location.pathname == '/sales/customer-payment' ? 'Customer Payment Details' : 'Supplier Payment Details'}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    {openOption === 'PaymentDetails' &&
                        <Customer_Supplier_PaymentDetails details={info} />
                    }
                </DialogContent>
            </BootstrapDialog>

            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={handleCloseSuccessMsg}
                    message={successMessage}
                    action={actionMsg}
                />
            }
        </>

    )
}

export default Customer_Supplier_PaymentList;
